export default function user({ next, router }) {
  if (
    localStorage.getItem(process.env.VUE_APP_NAME + "_profile_complete") ===
    "false"
  ) {
    Event.$emit(
      "ApiError",
      "Access Denied, complete your profile to continue!",
    );
    return router.replace({
      name: "Summary",
    });
  }
  return next();
}
